export enum VIEWS {
    primary = 'primary',
    secondary = 'secondary',
    readonly = 'readonly'
}

export enum VARIANTS {
    regular = 'regular',
    rounded = 'rounded'
}

export enum COLORS {
    success = 'success',
    negative = 'negative',
    info = 'info',
    revert = 'revert',
    generic = 'generic'
}

export enum SIZES {
    large = 'large',
    medium = 'medium',
    small = 'small'
}

export enum STATUSES {
    default = 'default',
    active = 'active',
    hover = 'hover'
}
